<template>
  <div class="head-page">
    <Header :title="$t('identity.title')" :isreturn="true" />
    <van-form ref="frm" @submit="onSubmit" style="margin-top: 5px">
      <van-field
        v-model="frm.real_name"
        :label="$t('identity.name')"
        :placeholder="$t('identity.nameplaceholder')"
        :rules="[{ required: true }]"
      />
      <div style="padding: 10px 16px">
        {{ $t("identity.uploader") }}
      </div>

      <van-row>
        <van-col :span="12" class="txt-center">
          <van-uploader
            v-model="uploader1"
            preview-size="160px"
            :max-count="1"
            :after-read="File1AferReade"
            :before-delete="file1Delete"
          />
        </van-col>
        <van-col :span="12" class="txt-center">
          <van-uploader
            v-model="uploader2"
            preview-size="160px"
            :max-count="1"
            :after-read="File1AferReade1"
            :before-delete="file2Delete"
          />
        </van-col>
        <van-col :span="12" class="txt-center">
          {{ $t("identity.tip1") }}
        </van-col>
        <van-col :span="12" class="txt-center">
          {{ $t("identity.tip2") }}
        </van-col>
      </van-row>
      <div style="margin: 16px">
        <van-button native-type="submit" class="web-btn"
          ><van-loading v-if="posting" /><span v-else>{{
            $t("common.confirm")
          }}</span></van-button
        >
      </div>
    </van-form>
  </div>
</template>
  
  <script>
import { getToken,getTokenbyName,TokenLangKey } from "@/utils/cookies";
import Axios from "axios";
import Header from "@/components/Header";
export default {
  name: "RealAuthentication",
  components: { Header },
  data() {
    return {
      active: 0,
      frm: {
        real_name: null,
        front_card: null,
        back_card: null,
      },
      uploader1: [],
      uploader2: [],
      img1: null,
      img2: null,
      posting: false,
    };
  },
  methods: {
    async onSubmit() {
      if (!(this.frm.front_card && this.frm.front_card.length > 0)) {
        this.$toast.fail(this.$t("identity.tip1"));
        return;
      }
      if (!(this.frm.back_card && this.frm.back_card.length > 0)) {
        this.$toast.fail(this.$t("identity.tip2"));
        return;
      }

      if (this.posting) {
        return;
      }
      this.posting = true;
      await this.$http({
        method: "post",
        url: "usrsetreal",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
        })
        .catch(() => {
          this.posting = false;
        });
    },
    tabChange() {
      this.phone = null;
      this.email = null;
      this.$refs.frm.resetValidation();
    },
    async fileUpload(file, type) {
      file.status = "uploading";
      const formData = new FormData();
      formData.append("file", file.file);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Token: getToken(),
          Lang: getTokenbyName(TokenLangKey),
        },
      };
      await Axios.post("/api/api/common/upload", formData, config)
        .then((response) => {
          file.status = "";
          if (type == 1) {
            this.img1 = response.data.data.fullurl;
            this.frm.front_card = response.data.data.url;
          }
          if (type == 2) {
            this.img2 = response.data.data.fullurl;
            this.frm.back_card = response.data.data.url;
          }
        })
        .catch((error) => {
          file.status = "failed";
          console.log(error);
        });
    },
    File1AferReade(file) {
      this.fileUpload(file, 1);
    },
    file1Delete() {
      this.img1 = null;
      this.frm.front_card = null;
      this.uploader1 = [];
    },
    File1AferReade1(file) {
      this.fileUpload(file, 2);
    },
    file2Delete() {
      this.img2 = null;
      this.frm.back_card = null;
      this.uploader2 = [];
    },
  },
};
</script>
  
  <style>
</style>
  